import { RELATED_AS_LABELS } from "../../../../api/stakeholder_relationships";
import { cn } from "../../../../lib/utils";
import { PartySuggestion } from "./derive";

/**
 * Suggestion card with a radio that turns green when selected. It can't be
 * unchecked directly — clicking a selected card is a no-op; it clears when the
 * linked party row is removed (which flips `selected` back to false).
 */
export const SuggestionCard: React.FC<{
  suggestion: PartySuggestion;
  onSelect: () => void;
}> = ({ suggestion, onSelect }) => (
  <button type="button" aria-pressed={suggestion.selected}
    onClick={() => !suggestion.selected && onSelect()}
    className={cn(
      "flex items-center justify-between gap-3 min-w-[200px] rounded-md border px-3 py-2 text-left transition-colors",
      suggestion.selected
        ? "border-green-500 bg-green-50 cursor-default"
        : "border-gray-200 bg-white hover:border-[#3551F3]"
    )}>
    <span className="flex flex-col">
      <span className="text-sm font-medium text-gray-900">{suggestion.name}</span>
      <span className="text-xs text-gray-500">
        {RELATED_AS_LABELS[suggestion.account_relationships[0].related_as]} • {suggestion.account_relationships[0].account_numbers.length} account
        {suggestion.account_relationships[0].account_numbers.length === 1 ? "" : "s"}
      </span>
    </span>
    <span className={cn(
      "flex h-4 w-4 shrink-0 items-center justify-center rounded-full border",
      suggestion.selected ? "border-green-500 bg-green-500" : "border-gray-300"
    )}>
      {suggestion.selected && <span className="h-1.5 w-1.5 rounded-full bg-white" />}
    </span>
  </button>
);
